export enum VisitCancellationStatusEnum {
  Success = 0,
  NotAllowed = 1,
  GenericError = 2
}
